import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { NavLink } from "react-router-dom";
import UploadDialog from "./Dialogues/UploadDialog";
// import ExportDataDialog from "./Dialogues/ExportDataDialog";
import swaasaLogo from "../Assets/images/Swaasa.png";
import apolloLogo from "../Assets/images/apollo.png";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import axios from "../axios";
import { createTheme, ThemeProvider } from "@mui/material";
import "../Assets/styles/newStyles/Navbar.css";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
// import HomeIcon from '@mui/icons-material/Home';
import { useLocation, useHistory } from "react-router-dom";
import profileIcon from "../Assets/images/profile-icon.svg";
import logoutButton from "../Assets/images/exit.png";
import PaymentsIcon from "@mui/icons-material/Payments";

const theme = createTheme({
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          "&:selected": {
            backgroundColor: "#ff7d00",
            color: "red",
            fontWeight: "bold",
          },
          "&:hover": {
            // backgroundColor: "#ffdcb7",
            // cursor: 'pointer'
          },
        },
      },
    },
  },
});

const useStyles = makeStyles({
  root: {
    // Your existing styles...
  },
  selected: {
    backgroundColor: "pink", // Change background color when selected
    color: "red",
    fontWeight: "bold",
  },
});

const BiggerListItemIcon = withStyles({
  root: {
    "& .MuiSvgIcon-root": { fontSize: "3rem" },
  },
})(ListItemIcon);

function Navbar({ onToggleCollapse }) {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [open, setOpen] = useState(false);
  // const [openExport, setOpenExport] = useState(false);

  // const [selectedItemIndex, setSelectedItemIndex] = useState(0)
  const [selectedItemIndex, setSelectedItemIndex] = useState(
    localStorage.validation === "true" &&
      localStorage.longitudinal_study !== "true"
      ? 1
      : 0
  );
  const [highlightedItemIndex, setHighlightedItemIndex] = useState(0);
  const [drawerWidth, setDrawerWidth] = useState(
    window.innerWidth >= 768 ? 240 : 180
  );
  const [collapsed, setCollapsed] = useState(false);
  const [prevSelectedItemIndex, setPrevSelectedItemIndex] = useState(0);
  const [balanceCount, setBalanceCount] = useState(0);
  const [doctorName, setDoctorName] = useState("");
  const [role, setRole] = useState("");
  const [popup, setPopup] = useState(null);
  

  useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(window.innerWidth >= 769 ? 240 : 180);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const storedIndex = localStorage.getItem("selectedItemIndex");
    if (storedIndex !== null) {
      setSelectedItemIndex(parseInt(storedIndex));
      setHighlightedItemIndex(parseInt(storedIndex));
    }
    getAssessmentsCount();
    getProfileApi();
  }, []);

  useEffect(() => {
    // Define a map of routes to their corresponding index in the Navbar
    const routeToIndexMap = {
      "/home": 0,
      "/validationHome": 1,
      "/patients": 2,
      "/assessments": 3,
      "/export": 4,
      "/payments": 5,
      "/drl-orgs": 6,
      "/drl-doctors":7
    };
    if (location.pathname.startsWith("/validationHome")) {
      setSelectedItemIndex(1);
      setHighlightedItemIndex(1);
    } else if (location.pathname.startsWith("/patient")) {
      setSelectedItemIndex(2);
      setHighlightedItemIndex(2);
    } else if (location.pathname.startsWith("/assessments")) {
      setSelectedItemIndex(3);
      setHighlightedItemIndex(3);
    } else if (location.pathname.startsWith("/export")) {
      setSelectedItemIndex(4);
      setHighlightedItemIndex(4);
    } else if (location.pathname.startsWith("/payments")) {
      setSelectedItemIndex(5);
      setHighlightedItemIndex(5);
    } else if (location.pathname.startsWith("/drl-orgs")) {
      setSelectedItemIndex(6);
      setHighlightedItemIndex(6);
    } else if (location.pathname.startsWith("/drl-doctors")) {
      setSelectedItemIndex(7);
      setHighlightedItemIndex(7);
    }
    else {
      if (localStorage.validation === true) {
        setSelectedItemIndex(1);
        setHighlightedItemIndex(1);
      }
      setSelectedItemIndex(0);
      setHighlightedItemIndex(0);
    }
  }, [location.pathname]);

  useEffect(() => {
    localStorage.setItem("selectedItemIndex", selectedItemIndex);
    localStorage.setItem("collapsed", collapsed);
  }, [selectedItemIndex, collapsed]);

  const setPrevIndex = () => {
    setPrevSelectedItemIndex(selectedItemIndex);
  };

  const styles = useStyles();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const openWindow = () => {
    // const paymentsUrl = 'http://localhost:3001';
    // const paymentsUrl = "https://payments-test.swaasa.ai/";
    const paymentsUrl = "https://payments.swaasa.ai/";
    const queryParams = localStorage.accessToken;
    const accessType = localStorage.accessType;

    const urlWithParams = `${paymentsUrl}?accessToken=${queryParams}&accessType=${accessType}`;
    const newWindow = window.open(
      urlWithParams,
      "newWindow",
      "width=1600,height=1000"
    );
    setPopup(newWindow);

    const checkWindowClosed = setInterval(() => {
      if (newWindow.closed) {
        clearInterval(checkWindowClosed);
        window.location.reload();
      }
    }, 1000);
  };

  const getProfileApi = () => {
    axios
      .get("/getProfile", {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        localStorage.setItem("accessType", response.data.data.accessType);
        localStorage.setItem("name", response.data.data.firstName);
        localStorage.setItem("role", response.data.data.role);
        setRole(response.data.data.role);
        setDoctorName(response.data.data.firstname);
      });
  };

  const getAssessmentsCount = async () => {
    const doctorId = localStorage.doctorId || localStorage.adminId;
    const encodedDoctorId = encodeURIComponent(doctorId);
    try {
      const response = await axios.get(
        `/user_balance_count?doctorId=${encodedDoctorId}`,
        {
          headers: { accessToken: localStorage.accessToken },
        }
      );
      setBalanceCount(response.data.balance_info);
    } catch (error) {
      console.log(error, "user balance count");
    }
  };

  const icons = [
    (localStorage.validation !== "true" ||
      localStorage.longitudinal_study === "true") && <HomeIcon />,
    localStorage.validation === "true" && <HomeIcon />,
    <PersonIcon />,
    <AssessmentIcon />,
    <CloudDownloadIcon />,
    <PaymentsIcon />,
    <AddBusinessIcon />,
    <PersonIcon />,
  ];

  // const handleCloseExport = () => {
  //   setOpenExport(false);
  //   // setHighlightedItemIndex(selectedItemIndex);
  //   setSelectedItemIndex(prevSelectedItemIndex);
  // };

  // const exportData = () => {
  //   axios
  //     .get(`/export-data/${localStorage.adminId}`, {
  //       headers: { accessToken: localStorage.accessToken },
  //       responseType: "blob",
  //     })
  //     .then((response) => {
  //       console.log(response);
  //       console.log(response.data);
  //       console.log(typeof response.data, "yrthff7");
  //       var today = new Date();
  //       var date =
  //         today.getFullYear() +
  //         "-" +
  //         (today.getMonth() + 1) +
  //         "-" +
  //         today.getDate();
  //       const fileName = localStorage.doctorId + "-(" + date + ").xlsx";
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //     });
  // };

  // const exportApolloData = () => {
  //   axios
  //     .get(
  //       `/export-executive-data?doctorId=${encodeURIComponent(
  //         localStorage.doctorId
  //       )}`,
  //       {
  //         headers: { accessToken: localStorage.accessToken },
  //         responseType: "blob",
  //       }
  //     )
  //     .then((response) => {
  //       console.log(response);
  //       console.log(response.data);
  //       var today = new Date();
  //       var date =
  //         today.getFullYear() +
  //         "-" +
  //         (today.getMonth() + 1) +
  //         "-" +
  //         today.getDate();
  //       const fileName = localStorage.doctorId + "-(" + date + ").xlsx";
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", fileName);
  //       document.body.appendChild(link);
  //       link.click();
  //     });
  // };

  const handleUpload = () => {
    setOpen(true);
    setPrevIndex();
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedItemIndex(prevSelectedItemIndex);
  };

  const handleListItemClick = (index, to) => {
    setSelectedItemIndex(index);
    if (to) {
      history.push(to);
    }
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
    // setDrawerWidth(collapsed ? window.innerWidth >= 769 ? 240 : 180 : 70);
    const width = collapsed ? (window.innerWidth >= 769 ? 240 : 180) : 70;
    setDrawerWidth(width);
    // localStorage.setItem("navbarWidth", `${width}px`);
    onToggleCollapse(!collapsed);
  };
  const history = useHistory();

  const handleLogout = () => {
    localStorage.clear(); // Clear local storage
    history.push("/"); // Redirect to the login page
  };

  const drawer = (
    <ThemeProvider theme={theme}>
      <img
        className={
          localStorage.adminId === "admin@apollo.com"
            ? "apollo-logo-img"
            : "nav-logo-img"
        }
        src={
          localStorage.adminId === "admin@apollo.com" ? apolloLogo : swaasaLogo
        }
        alt="logo"
        style={{
          width: collapsed ? "66px" : "",
          height: collapsed ? "20px" : "",
          margin: collapsed ? "20px 0 20px 2px" : "",
        }}
      />
      <Divider />
      <div className="collapse-container" onClick={toggleCollapse}>
        {!collapsed ? (
          <p className="collapse-text">Collapse</p>
        ) : (
          // <p className="collapse-text">Expand</p>
          ""
        )}
        {collapsed ? (
          <KeyboardDoubleArrowRightIcon sx={{ color: "#ff7208" }} />
        ) : (
          <KeyboardDoubleArrowLeftIcon sx={{ color: "#ff7208" }} />
        )}
      </div>
      <List className={styles.root} sx={{height:'54vh',overflowY: "auto"}}>
        {[
          (localStorage.validation !== "true" ||
            localStorage.longitudinal_study === "true") && {
            text: "Home",
            to: "/home",
            tooltip: "View Analytics",
          },
          localStorage.validation === "true" &&
            localStorage.longitudinal_study !== "true" && {
              text: "Home",
              to: "/validationHome",
              tooltip: "Home",
            },
          { text: "Patients", to: "/patients", tooltip: "View Patients" },
          (localStorage.validation !== "true" ||
            localStorage.longitudinal_study === "true") && {
            text: "Assessments",
            to: "/assessments",
            tooltip: "View Assessments",
          },
          localStorage.export_data === "true" && {
            text: "Export",
            to: "/export",
            tooltip: "Export Data",
          },
          localStorage.patientPayment === "true" && localStorage.clinics === "true" && {
            text: "Accounts",
            to: "/payments",
            tooltip: "View Payments",
          },
          localStorage.patientPayment === "true" && localStorage.clinics === "false" && {
            text: "DRL Orgs",
            to: "/drl-orgs",
            tooltip: "View DRL Orgs",
          },
          localStorage.patientPayment === "true" && localStorage.clinics === "false" && {
            text: "DRL Doctors",
            to: "/drl-doctors",
            tooltip: "View DRL Doctors",
          },
        ].map(
          (item, index) =>
            item && (
              <ListItem
                key={item.text}
                onClick={() => handleListItemClick(index, item.to)}
                classes={{ selected: styles.selected }}
                sx={{
                  backgroundColor:
                    selectedItemIndex === index ? "#ffdcb7" : "inherit",
                  fontWeight: selectedItemIndex === index ? "bold" : "normal",
                }}
                disablePadding
              >
                <ListItemButton>
                  <ListItemIcon sx={{ minWidth: "30px", borderRadius: "4px" }}>
                    <BiggerListItemIcon>{icons[index]}</BiggerListItemIcon>
                  </ListItemIcon>
                  {!collapsed && <ListItemText primary={item.text} />}
                </ListItemButton>
              </ListItem>
            )
        )}
        {localStorage.bulkupload === "true" && (
          <ListItemButton onClick={handleUpload}>
            <ListItemIcon>
              <BiggerListItemIcon>
                <UploadFileIcon />
              </BiggerListItemIcon>
            </ListItemIcon>
            <ListItemText primary="Upload" />
          </ListItemButton>
        )}
      </List>
      {!collapsed && (
        <div className="navbar-footer">
          <div className="profile-container">
            <div className="logout-container">
              <img className="profile-icon-img" src={profileIcon} alt="" />
            </div>
            <div className="profile-names">
              <p
                className="doctor-name-navbar"
                style={{ textTransform: "capitalize" }}
              >
                <p
                  className="doctor-name-navbar"
                  style={{
                    textTransform: "capitalize",
                    wordBreak: "break-word",
                    width: "100%", // or specify any specific width
                  }}
                >
                  {doctorName}
                </p>
              </p>
              <p
                className="topbar-role"
                style={{ textTransform: "capitalize" }}
              >
                {role}
              </p>
            </div>
            <div>
              <img
                onClick={handleLogout}
                className="logout-btn"
                src={logoutButton}
                alt=""
              />
            </div>
          </div>
          {/* To Hide Assessments left  card in longitudinal study and validation*/}
          {localStorage.validation !== "true" &&
  localStorage.longitudinal_study !== "true" &&
  localStorage.patientPayment !== "true" && ( // Add condition to hide if patientPayment is true
    <div className="assessments-count-card">
      <p className="assessments-left">Assessments Left</p>
      <p className="assessments-count">
        {Math.max(balanceCount, 0)}
        <span className="assessments-count2"></span>
      </p>
      <button className="recharge-button" onClick={openWindow}>
        Recharge
      </button>
    </div>
  )}

          <p className="powered-by">Powered by</p>
          <p className="swaasa-ai">Swaasa.AI</p>
          <p className="swaasa-version">
            Swaasa AI Platform {process.env.REACT_APP_SWAASA_VERSION}
          </p>
          <p className="swaasa-version">
            Dashboard {process.env.REACT_APP_VERSION}
          </p>
        </div>
      )}
    </ThemeProvider>
  );

  return (
    <div
    // className="navbar"
    >
      <ThemeProvider theme={theme}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon
            sx={{ color: "orange", fontSize: 32, marginLeft: "20px" }}
          />
          <span style={{ marginLeft: "10px" }}>Menu</span>
        </IconButton>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              fontSize: "2.5rem",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
        {/* <ExportDataDialog
          openExport={openExport}
          handleCloseExport={(data) => handleCloseExport()}
          handleExport={exportData}
          handleExportApollo={exportApolloData}
        /> */}
        <UploadDialog
          open={open}
          handleClose={(data) => handleClose()}
        ></UploadDialog>
      </ThemeProvider>
    </div>
  );
}

Navbar.propTypes = {
  onToggleCollapse: PropTypes.func.isRequired,
};

export default Navbar;
